<!-- layout edicao -->
<div class="main-content flex pb-8">
  <!-- Sidebar com stepper -->
  <div class="side-bar w-1/5 py-4 px-10">
    <!-- Cabeçalho -->
    <div class="mb-8">
      <div class="w-fit border-sm-full {{corBordaTitulo}} rounded-xl py-1 px-3">
        <span class="{{corTextoTitulo}} text-body-md font-regular ">
          {{tituloResultado}}
        </span>
      </div>
    </div>

    <!-- Ilustração e informações da localização -->
    <div class="ilustration-container flex gap-4">
      <img [src]="imagemFundo" alt="ilustration">

      <div class="flex flex-col justify-between">
        <div>
          <span class="text-charcoal-800 text-body-lg">{{redeSelecionada}}</span>
          <span class="text-charcoal-800 text-body-lg"> /</span>
          <br>
          <span class="text-charcoal-800 text-body-lg">{{pais}} </span>
          <span class="text-charcoal-800 text-body-lg">/ </span>
          <span class="text-charcoal-800 text-body-lg">{{estado}}</span>
        </div>

        <div>
          <span class="text-blue-500 text-heading-sm text-bold">{{cidade}} {{ano}}</span>
        </div>
      </div>
    </div>

    <!-- Componente Stepper (apenas wizard + botões) -->
    <app-stepper-navigation (navegacao)="onStepperNavegacao($event)"></app-stepper-navigation>
  </div>

  <!-- Popup de inconsistências -->
  <app-popup-validacao
    [visivel]="mostrarPopupValidacao"
    [permitirContinuar]="true"
    (fechar)="onPopupFechar()"
    (continuarMesmoAssim)="onPopupContinuarMesmoAssim()"
    (corrigirErros)="onPopupCorrigirErros()">
  </app-popup-validacao>

  <!-- Conteúdo principal -->
  <div class="content w-4/5 pt-14 px-8 bg-gray-100">
    <router-outlet></router-outlet>
  </div>
</div>
